/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BackButton from '@ba-ui-toolkit/backbutton';
import { propsUtils } from '@ba-ui-toolkit/utils';
import folderOverflow16 from '@ba-ui-toolkit/ba-graphics/dist/icons-js/folder-overflow_16.js';
import { Breadcrumb as CarbonBreadcrumb } from 'carbon';
import Label from '@ba-ui-toolkit/label';
import BreadcrumbItem from './BreadcrumbItem';

const { BaPropTypes } = propsUtils;

export default class Breadcrumb extends Component {
	// @param ancestors-  an array of objects @param callback()- the callback
	// function that will handle the navigation when a user clicks on a crumb
	static propTypes = {
		/** Pass an array of js objects that detail the ancestors of the current crumb node. The minimum requirements are an id, a defaultName and an icon */
		ancestors: PropTypes.array,
		/** pass a callback function that defines the behaviour when clicking on a crumb node */
		navCallback: PropTypes.func,
		/** Pass a callback function that defines the behaviour of clicking the back button */
		historyCallback: PropTypes.func,
		/** Pass a custom icon for the context menu. Default icon is folder-overflow_16 */
		menuIcon: BaPropTypes.deprecated('is ignored and not applicable to carbon breadcrumb'),
		/** String value to display different font-sizes Options: small, medium(default), large */
		size: BaPropTypes.deprecated('is ignored and not applicable to carbon breadcrumb'),
		/** Boolean value to show/hide the back button */
		hideBackButton: PropTypes.bool,
		/** Custom class name(s) */
		className: PropTypes.string,
		/** Custom css styles */
		style: PropTypes.object,
		/** text direction */
		textDir: PropTypes.oneOf(['', 'ltr', 'rtl', 'auto']),
		/** Optional prop to omit the trailing slash for the breadcrumbs */
		noTrailingSlash: PropTypes.bool,
	};

	static defaultProps = {
		ancestors: [],
		menuIcon: folderOverflow16,
		size: 'medium',
		hideBackButton: false,
		className: '',
		style: {},
	};

	/*
	 * CALLBACKS
	 */

	_onBackButtonClick = () => {
		this.props.historyCallback();
	};

	_onBreadCrumbClick = (currentNode, id) => {
		!currentNode && this.props.navCallback && this.props.navCallback(id);
	};

	render() {
		const {
			ancestors,
			hideBackButton,
			className,
			style,
			textDir,
			noTrailingSlash,
		} = this.props;

		// show/hide back button node
		const backButtonNode = !hideBackButton && (
			<div style={{ marginRight: '8px' }}>
				<BackButton buttonType="nav_pane" onClick={this._onBackButtonClick} />
			</div>
		);

		// create crumb item nodes
		const crumbNodes = ancestors.map((currVal, index, ancestorsArr) => {
			const isValue = !!currVal.defaultName;
			const currentNode = index === ancestorsArr.length - 1;

			let breadcrumb;
			if (isValue) {
				breadcrumb = (
					<BreadcrumbItem
						key={index}
						className
						isCurrentPage={currentNode}
						onClick={() => this._onBreadCrumbClick(currentNode, index)}
					>
						<Label
							style={{ userSelect: 'all' }}
							label={currVal.defaultName}
							ellipsis
							location={currentNode ? 'end' : 'middle'}
							textDir={textDir}
						/>
					</BreadcrumbItem>
				);
			}

			return breadcrumb;
		});

		return (
			<CarbonBreadcrumb className={className} style={style} noTrailingSlash={noTrailingSlash}>
				{backButtonNode}
				{crumbNodes}
			</CarbonBreadcrumb>
		);
	}
}
